<template>
  <View v-if="property?.parking?.hasParking === false" gap="sm" align="center">
    <Text as="span" variant="body-medium" color="tertiary"><Icon name="car-01" size="small" /></Text>
    <Text variant="body-medium">No parking available</Text>
  </View>

  <PropertyDetailsCardRows v-else>
    <PropertyDetailsCardInfoItem
      v-if="property?.parking?.parkingType"
      label="Parking Type"
      icon="car-01"
      :value="property?.parking?.parkingType"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.parking?.parkingAvailableSpaces"
      label="Available spaces"
      icon="columns-03"
      :value="property?.parking?.parkingAvailableSpaces"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.parking?.parkingMonthlyChargePerSpace"
      label="Monthly charge per space"
      icon="currency-dollar-circle"
      :value="`$${property?.parking?.parkingMonthlyChargePerSpace}`"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.parking?.parkingSpacesAreTandem !== null"
      label="Spaces are tandem"
      icon="switch-horizontal-01"
      :value="property?.parking?.parkingSpacesAreTandem ? 'Yes' : 'No'"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.parking?.parkingOtherDescription"
      label="Description"
      icon="align-left"
      :value="property?.parking?.parkingOtherDescription"
    />
  </PropertyDetailsCardRows>
</template>

<script setup lang="ts">
import { Icon, Text, View } from '@tallo/design-system';

import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

defineProps<{
  property: PropertyDto | null | undefined;
}>();
</script>
